<template>
  <div class="paginator">
    <div class="inline-block">
      <div class="inline-block">
        <button
          @click="goPreviousPage()"
          class="page-item"
          v-if="currentPage > 2"
        >
          <v-icon class="next-icon">arrow_back_ios_new</v-icon>
        </button>
        <button
          class="page-item"
          :class="[
            page == '...' ? 'disabled' : '',
            currentPage == page ? 'active' : ''
          ]"
          v-for="(page, index) in pages"
          :key="index"
          @click="goPage(page)"
        >
          {{ page }}
        </button>
        <button
          @click="goNextPage()"
          class="page-item"
          v-if="currentPage !== totalPages"
        >
          <v-icon class="next-icon">arrow_forward_ios</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'component-paginator',
  props: ['totalItems', 'currentPages', 'itemsPerPage'],
  mixins: [],
  data() {
    return {
      pages: [],
      totalPages: 0,
      currentPage: this.currentPages
    };
  },
  watch: {
    currentPage: {
      handler(newValue) {
        if (newValue) {
          this.setupPaginator()
        }
      },
    },
    totalItems: {
      handler(newValue) {
        if (newValue) {
          this.setupPaginator()
        }
      },
    }
  },
  methods: {
    getPagination(currentPage, totalPages) {
      var num = Math.ceil(totalPages);

      const delta = 1,
        left = currentPage - delta,
        right = currentPage + delta + 1,
        range = [],
        rangeString = [];
      let tmp = 0;

      for (let i = 1; i <= num; i++) {
        if (i == 1 || i == num || (i >= left && i < right)) {
          range.push(i);
        }
      }

      for (const i of range) {
        if (tmp) {
          if (i - tmp === 2) {
            rangeString.push((tmp + 1).toString());
          } else if (i - tmp !== 1) {
            rangeString.push('...');
          }
        }
        rangeString.push(i.toString());
        tmp = i;
      }

      return rangeString;
    },
    goPreviousPage() {
      if (this.currentPage) {
        this.currentPage = this.currentPage - 1;
        this.pages = this.getPagination(this.currentPage, this.totalPages);
        this.$emit("onGoPage", this.currentPage);
      }
    },

    goNextPage() {
      if (this.currentPage) {
        this.currentPage = this.currentPage + 1;
        this.pages = this.getPagination(this.currentPage, this.totalPages);
        this.$emit("onGoPage", this.currentPage);
      }
    },

    goPage(page) {
      if (Number(page) !== this.currentPage) {
        this.currentPage = Number(page);
        this.pages = this.getPagination(this.currentPage, this.totalPages);
        this.$emit("onGoPage",this.currentPage);
      }
    },
    setupPaginator() {
      console.log(this.totalItems, this.currentPage, this.itemsPerPage);
      this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
      this.pages = this.getPagination(this.currentPage, this.totalPages);
    }
  },

  mounted() {
    this.setupPaginator()
  }
};
</script>

<style scoped>

.next-icon {
  font-size: 20px;
}

.paginator {
  width: 100% !important;
  display: contents;
}

.inline-block {
  display: flex;
}

.page-item {
  background-color: #8d949e;
  width: 35px;
  height: 35px;
  border-color: transparent;
  margin: 5px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
  cursor: pointer;
}

.page-item:hover {
  background-color: #96b1d6;
}

.page-item.active {
  background-color: #4a001f;
  color: white;
  cursor:unset;
}

.page-item.disabled {
  cursor: auto;
  pointer-events: none;
  background-color: #8d949e;
}
</style>
